export const columnsWithFileMap = {
  invalidSkus: 'invalid_skus',
  missingChangeOvers: 'missing_change_overs',
  orphanedDemand: 'orphaned_demand',
}

export const columnDefinitions = {
  invalid_skus: [
    {
      headerName: 'Workcentre code',
      field: 'workCentreCode',
      flex: 1,
    },
    {
      headerName: 'SKU',
      field: 'skuCode',
      flex: 1,
    },
    {
      headerName: 'Batch',
      field: 'batchGroupingCode',
      flex: 1,
    },
    {
      headerName: 'PLT',
      field: 'productionLeadTime',
      flex: 1,
    },
    {
      headerName: 'MOQ',
      field: 'minimumProductionOrderQuantity',
      flex: 1,
    },
    {
      headerName: 'MOI',
      field: 'minimumProductionOrderIncrement',
      flex: 1,
    },
    {
      headerName: 'MOQ UOM',
      field: 'minProductionUnitOfMeasureCode',
      flex: 1,
    },
    {
      headerName: 'RR',
      field: 'runRate',
      flex: 1,
    },
    {
      headerName: 'RR UOM',
      field: 'runRateUnitOfMeasureCode',
      flex: 1,
    },
    {
      headerName: 'Current default WC',
      field: 'currentDefaultWorkCentreCode',
      flex: 1,
    },
    {
      headerName: 'Site holds stock',
      field: 'siteHoldsStock',
      flex: 1,
    },
    {
      headerName: 'Valid from date',
      field: 'validFromDate',
      flex: 1,
    },
  ],
  missing_change_overs: [
    {
      headerName: 'WC',
      field: 'workCentreCode',
      flex: 1,
    },
    {
      headerName: 'From SKU',
      field: 'fromSkuCode',
      flex: 1,
    },
    {
      headerName: 'To SKU',
      field: 'toSkuCode',
      flex: 1,
    },
    {
      headerName: 'Co time',
      field: 'changeOverTimeInMinutes',
      flex: 1,
    },
    {
      headerName: 'Co cost',
      field: 'changeOverCostInCurrency',
      flex: 1,
      cellClassName: 'red-column',
    },
  ],
  orphaned_demand: [
    {
      headerName: 'SKU',
      field: 'skuCode',
      flex: 1,
    },
    {
      headerName: 'Destination site',
      field: 'destinationSiteCode',
      flex: 1,
    },
    {
      headerName: 'Valid from',
      field: 'validFromDate',
      flex: 1,
      cellClassName: 'red-column',
    },
    {
      headerName: 'Source site',
      field: 'sourceSiteCode',
      flex: 1,
    },
    {
      headerName: 'DLT',
      field: 'deliveryLeadTime',
      flex: 1,
    },
    {
      headerName: 'MOQ',
      field: 'minimumProductionOrderQuantity',
      flex: 1,
    },
    {
      headerName: 'MOI',
      field: 'minimumProductionOrderIncrement',
      flex: 1,
    },
    {
      headerName: 'UOM',
      field: 'unitOfMeasureCode',
      flex: 1,
    },
    {
      headerName: 'Valid To',
      field: 'validToDate',
      flex: 1,
      cellClassName: 'red-column',
    },
  ],
}
